import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMessages from "@faire/web-api--source/routes/brand-portal/messages";
import React, { type JSX } from "react";

import { Bold } from "../../common/Bold";

export const SWFShipped: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="This order has been marked as shipped, so you can no longer edit the tracking information. When a Ship with Faire label has been used or the shipment is already in transit, you won’t be able to cancel the label and create a new one. Reach out to our support team for help, so your retailer receives the correct information."
          description={{
            text: "The description for the instant answer about updating shipping information",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Additionally, you can send a message to the retailer via <ButtonFormatting>Faire messenger</ButtonFormatting> to provide correct shipping information."
          description={{
            text: "The description for the instant answer about updating shipping information",
          }}
          values={{
            ButtonFormatting: (chunks: JSX.Element) =>
              FaireMessagingFormatting(chunks),
          }}
        />
      </Typography>
    </Column>
  );
};

const FaireMessagingFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMessages()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);
